/*
 * <steals-wishlist-button> — Heart toggle for product cards and PDP
 */

// Handle cache: maps product IDs to handles for fast wishlist page loading
const _wishlistHandleCache = (() => {
  const KEY = 'steals-wishlist-handles';

  function getAll() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
  }

  function save(map) {
    localStorage.setItem(KEY, JSON.stringify(map));
  }

  function set(id, handle) {
    if (!id || !handle) return;
    const map = getAll();
    map[String(id)] = handle;
    save(map);
  }

  function remove(id) {
    const map = getAll();
    delete map[String(id)];
    save(map);
  }

  function getHandles(ids) {
    const map = getAll();
    return ids.map(id => map[String(id)]).filter(Boolean);
  }

  return { set, remove, getHandles, getAll };
})();

// Expose globally for wishlist page
window.StealsWishlistHandles = _wishlistHandleCache;

class StealsWishlistButton extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.productHandle = this.dataset.productHandle;
    this._onWishlistChanged = this._onWishlistChanged.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.steals-wishlist-btn__toggle');
    if (!this.button || !this.productId) return;

    // Cache handle if we have it and product is already favorited
    if (this.productHandle && StealsWishlist.has(this.productId)) {
      _wishlistHandleCache.set(this.productId, this.productHandle);
    }

    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this._toggle();
    });

    this._unsubscribe = subscribe('wishlist:changed', this._onWishlistChanged);
    this._render();
  }

  disconnectedCallback() {
    if (this._unsubscribe) this._unsubscribe();
  }

  async _toggle() {
    const added = await StealsWishlist.toggle(this.productId);
    if (added) {
      _wishlistHandleCache.set(this.productId, this.productHandle);
      this.setAttribute('data-animating', '');
      setTimeout(() => this.removeAttribute('data-animating'), 250);
    } else {
      _wishlistHandleCache.remove(this.productId);
    }
  }

  _onWishlistChanged() {
    this._render();
  }

  _render() {
    const active = StealsWishlist.has(this.productId);
    if (active) {
      this.setAttribute('data-active', '');
      this.button.setAttribute('aria-pressed', 'true');
    } else {
      this.removeAttribute('data-active');
      this.button.setAttribute('aria-pressed', 'false');
    }
  }
}

if (!customElements.get('steals-wishlist-button')) {
  customElements.define('steals-wishlist-button', StealsWishlistButton);
}

// Header wishlist counter
function updateWishlistCounter() {
  const badge = document.querySelector('[data-wishlist-count]');
  if (!badge) return;
  const count = StealsWishlist.count();
  if (count > 0) {
    badge.textContent = count > 99 ? '+' : count;
    badge.classList.remove('hidden');
  } else {
    badge.classList.add('hidden');
  }
}

subscribe('wishlist:changed', updateWishlistCounter);
StealsWishlist.init().then(updateWishlistCounter);
